<template>
  <v-dialog persistent v-model="value" max-width="700px" scrollable>
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">Crear pregunta</span>
      </v-card-title>
      <v-card-text style="max-height: 700px;">
        <v-layout wrap row>
          <v-flex xs12 md12 lg12>
            <v-textarea
              label="Pregunta"
              v-model="questionForm.question"
              name="Pregunta"
              :error-messages="preguntaErrors"
              rows="2"
              row-height="24"
              auto-grow
            />
          </v-flex>
        </v-layout>
        <v-layout wrap row>
          <v-flex xs12 md12 lg12>
            <v-select
              :items="types"
              item-text="name"
              item-value="value"
              return-object
              v-model="questionForm.type"
              label="Selecciona el el tipo"
              :errorMessages="typeErrors"
              :disabled="textFields.length > 2 ? true : false"
              required
            />
          </v-flex>
        </v-layout>
        <v-layout wrap row>
          <v-flex xs1 md1 lg1 class="add-answer">
            <v-tooltip right>
              <v-btn
                color="gradiente"
                dark
                small
                right
                fab
                slot="activator"
                @click="addAnswer"
                :disabled="questionForm.type.value === 'SIMPLE' ? (textFields.length >= 2 ? true : false) : false"
              >
                <v-icon>add</v-icon>
              </v-btn>
              <span>Agregar respuesta</span>
            </v-tooltip>
          </v-flex>
          
          <v-flex xs9 md9 lg9 style="text-align: center; display: flex; justify-content: center; align-items: center;">
            <label align-center>
              <b>Respuestas</b>
            </label>
          </v-flex>
        </v-layout>

        <div v-for="(textField, i) in textFields" :key="i" class="text-fields-row">
          <v-layout wrap row>
            <v-flex xs11 md11 lg11>
              <v-text-field
                v-model="textField.value"
              />
            </v-flex>
            <v-flex xs1 md1 lg1>
              <v-tooltip bottom>
                <v-btn icon slot="activator" @click="removeAnsewer(i)">
                  <v-icon color="red">cancel</v-icon>
                </v-btn>
                <span>Eliminar respuesta</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="close" flat>Cancelar</v-btn>
        <v-spacer/>
        <v-btn @click="save" color="primary" flat>Guardar</v-btn>
      </v-card-actions>
    </v-card>
    <warning v-model="toast.warning" :text="toast.description"/>
  </v-dialog>
</template>

<script>




import { required } from "vuelidate/lib/validators";
import warning from "../Dialogs/warning";


export default {
  components: {
    warning
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    poll: {
      type: Object,
      required: true
    },
  },
  validations: {
    questionForm: {
      question: { required },
      type: { required }
    }
  },
  watch: {
    value() {
      if (this.value && this.flags.cancel) {
        this.flags.cancel = false;
      }
    },
  },
  mounted() {
    console.log(this.poll);
  },
  data: () => ({
    questionForm: {
      question: "",
      type: "",
      answers: [],
    },
    toast: {
      description: "",
      warning: false
    },
    flags: {
      cancel: false,
      loading: false,
    },
    pagination: {
      sortBy: "name",
    },
    types: [
      {name: "SIMPLE", value: "SINGLE"},
      {name: "MULTIPLE", value: "MULTIPLE"}
    ],
    headers: [
      {
        text: "Respuesta",
        align: "left",
        value: "answer",
        filterItems: [],
      },
      {
        text: "",
        value: "id",
        filterItems: [],
        align: "center",
      }
    ],
    working: {
      wAnswer: false,
      wLoading: false,
    },
    textFields: [],
  }),
  methods: {
    save(){
      this.$v.questionForm.$touch();
      if(!this.$v.questionForm.$invalid){
        if(this.validAnswers()){
          this.textFields.forEach(textField => {
            this.questionForm.answers.push({
              answer: textField.value
            });
          });
          this.poll.pollQuestions.push(this.questionForm);
          this.questionForm = {
            question: "",
            type: "",
            answers: [],
          };
          this.textFields = [];
          this.$v.questionForm.$reset();
          this.$emit("created");
        }
      }
    },
    validAnswers(){
      var answersValid = true;
      if(this.textFields.length === 0){
        this.toast = {
          description : "No has agregado respuestas",
          warning: true
        }
        return false;
      }
      if(this.textFields.length === 1){
        this.toast = {
          description : "Agrega más de una respuesta",
          warning: true
        }
        return false;
      }
      
      this.textFields.forEach(textField => {
        if(textField.value === "" ){
          this.toast = {
            description : "Llena todas las respuesta",
            warning: true
          }
          answersValid = false;
        }
      });
      return answersValid;
    },
    close() {
      this.questionForm = {
        question: "",
        type: "",
        answers: [],
      };
      this.textFields = [];
      this.flags.cancel = true;
      this.$v.questionForm.$reset();
      this.$emit("onClosedQuestion", false);
    },
    addAnswer(){
      this.textFields.push({
        value: ""
      });
    },
    removeAnsewer(index){
      this.textFields.splice(index, 1);
    }
  },
  computed: {
   preguntaErrors() {
      if (!this.$v.questionForm.question.$dirty && !this.$v.questionForm.question.$model) {
        return ["Pregunta requerido"];
      }
      return [];
    },
    typeErrors() {
      if (!this.$v.questionForm.type.$dirty && !this.$v.questionForm.type.$model) {
        return ["Tipo requerido"];
      }
      return [];
    }
  },
};
</script>

<style>
.add-answer .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: hsl(0deg 100% 50% / 40%)!important;
}
</style>
